// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GridListSwitcher {
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 1fr 1fr;
}
.GridListSwitcher button {
  display: block;
  height: 20px;
  margin: 0;
  padding: 0;
}
.GridListSwitcher svg {
  fill: var(--gray);
  width: 20px;
  height: 20px;
}
.GridListSwitcher button:hover svg,
.GridListSwitcher .active svg {
  fill: var(--color_primary_500);
}`, "",{"version":3,"sources":["webpack://./src/components/GridListSwitcher/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;AACF;AACE;EACE,cAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AACJ;AAEE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAKI;;EACE,8BAAA;AAFN","sourcesContent":[".GridListSwitcher {\n  display: grid;\n  grid-column-gap: 16px;\n  grid-template-columns: 1fr 1fr;\n\n  button {\n    display: block;\n    height: 20px;\n    margin: 0;\n    padding: 0;\n  }\n\n  svg {\n    fill: var(--gray);\n    width: 20px;\n    height: 20px;\n  }\n\n  button:hover,\n  .active {\n    svg {\n      fill: var(--color_primary_500);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
